module.exports = __webpack_public_path__ + "media/images/checkout/challenger/chevron_down-2cf4f409f682d4a36ac725a8c5443cef.svg";